import { withActions } from '@/modules/shared/hocs/withActions'
import AdministrationPanel, {
  AdministrationPanelStateProps,
  AdministrationPanelDispatchProps,
  AdministrationPanelOwnProps,
} from '../../components/administration/administrationPanel'
import { withLoading } from '@/modules/shared/hocs/withLoading'
import { getCompany } from 'app/actions/company'

export function mapDispatchToProps(): AdministrationPanelDispatchProps {
  return {
    getCompany: (companyId: string) => getCompany(companyId, true),
  }
}

export default withLoading(
  withActions(AdministrationPanel, mapDispatchToProps()) as any,
) as unknown as React.ComponentClass<AdministrationPanelOwnProps>
